"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.stateFreezer = void 0;
const deepFreeze_1 = require("../utils/deepFreeze");
function stateFreezer(reducer) {
    return function freezer(state, action) {
        (0, deepFreeze_1.deepFreeze)(state);
        const newState = reducer(state, action);
        (0, deepFreeze_1.deepFreeze)(newState);
        return newState;
    };
}
exports.stateFreezer = stateFreezer;
//# sourceMappingURL=stateFreezer.js.map